export const NEW_CRITERIONS = {
	WALK: {
		SMOOTH: 133,
		RUN: 134,
	},
	BIKE: {
		CYCLO_TURIST: 121,
		ROAD: 122,
		MTB: 123,
		GRAVEL_TREKING: 124,
		SCOOTER: 125,
	},
	SKI: {
		SKI_ALPS: 142,
	},
};
export const PREMIUM_CRITERIONS: Array<number> = [
	NEW_CRITERIONS.WALK.SMOOTH,
	NEW_CRITERIONS.WALK.RUN,
	NEW_CRITERIONS.BIKE.GRAVEL_TREKING,
	NEW_CRITERIONS.BIKE.SCOOTER,
	NEW_CRITERIONS.SKI.SKI_ALPS,
];

interface IRouteParams {
	criterion?: number;
	allowViaFerrata?: boolean;
	avoidHighways?: boolean;
}

export function isRouteReadOnly(isUserPremium: boolean, routeParams: IRouteParams) {
	const criterion = routeParams.criterion || 0;

	return isUserPremium
		? false
		: PREMIUM_CRITERIONS.includes(criterion) || routeParams.allowViaFerrata || routeParams.avoidHighways;
}
